import { render, staticRenderFns } from "./GLYF_Expert_Page.vue?vue&type=template&id=47f466fb&scoped=true"
import script from "./GLYF_Expert_Page.vue?vue&type=script&lang=js"
export * from "./GLYF_Expert_Page.vue?vue&type=script&lang=js"
import style0 from "./GLYF_Expert_Page.vue?vue&type=style&index=0&id=47f466fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f466fb",
  null
  
)

export default component.exports